import { z } from 'zod';
import { emailSchema, nameSchema, passwordSchema, redirectSchema } from './common.js';
export const registerSchema = z.object({
    email: emailSchema,
    name: nameSchema,
    password: passwordSchema,
    spaceName: z.string().trim().min(1).max(160).optional(),
});
export const loginSchema = z.object({ email: emailSchema, password: z.string().min(1).max(256) });
export const magicLinkRequestSchema = z.object({ email: emailSchema, redirect: redirectSchema });
export const tokenSchema = z.object({ token: z.string().min(20).max(200) });
export const changePasswordSchema = z.object({
    /** Не нужен, если пароля ещё нет (вход был по ссылке или через OAuth). */
    currentPassword: z.string().max(256).optional(),
    newPassword: passwordSchema,
});
export const passwordResetRequestSchema = z.object({ email: emailSchema });
export const passwordResetSchema = z.object({ token: z.string().min(20).max(200), newPassword: passwordSchema });
export const updateMeSchema = z
    .object({
    name: nameSchema,
    title: z.string().trim().max(120),
    timezone: z
        .string()
        .max(64)
        .refine((tz) => Intl.supportedValuesOf('timeZone').includes(tz) || tz === 'UTC', 'Неизвестный часовой пояс'),
    locale: z.enum(['ru', 'en']),
    notificationPrefs: z.object({ mentions: z.boolean(), digest: z.boolean(), product: z.boolean() }),
})
    .partial();
export const deleteAccountSchema = z.object({ confirmEmail: emailSchema });
//# sourceMappingURL=auth.js.map